import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';
import Card from '@quintoandar/cozy-core/Card';
import withTheme from '@quintoandar/cozy-utils/hocs/withTheme';
import PropTypes from 'prop-types';

import ChecklistTitleWrapper from 'containers/Checklist/ChecklistTitleWrapper';

export const ContentHeader = ({
  headerTitle,
  headerSubtitle,
  instructionsCardTitle,
  instructionsCardTitleIcon,
  instructions,
}) => (
  <Box>
    <ChecklistTitleWrapper mb={3}>
      <Typography level="heading">
        <FormattedMessage {...headerTitle} />
      </Typography>
    </ChecklistTitleWrapper>
    {headerSubtitle && (
      <Box mb={4}>
        <Typography kind="lighter">
          <FormattedMessage {...headerSubtitle} />
        </Typography>
      </Box>
    )}
    <Card>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        {instructionsCardTitleIcon()}
        <Box ml={1}>
          <Typography>
            <FormattedMessage {...instructionsCardTitle} />
          </Typography>
        </Box>
      </Box>
      <Typography kind="lighter">
        <ul>
          {instructions &&
            instructions.map(instruction => (
              <li data-testid="instructions">
                <FormattedMessage {...instruction.message} />{' '}
                {instruction.bold && (
                  <Typography level="bodyStrong" inline>
                    <FormattedMessage {...instruction.bold} />
                  </Typography>
                )}
                {instruction.messageEnd && (
                  <FormattedMessage {...instruction.messageEnd} />
                )}
              </li>
            ))}
        </ul>
      </Typography>
    </Card>
  </Box>
);

ContentHeader.propTypes = {
  headerTitle: PropTypes.object,
  headerSubtitle: PropTypes.object,
  instructionsCardTitle: PropTypes.object,
  instructionsCardTitleIcon: PropTypes.func,
  instructions: PropTypes.array,
};

export default withTheme(ContentHeader);
